const CONFETTI_DOTS = [
  { top: '8%', left: '10%', size: 18, color: '#fbbf24', rotate: 12 },
  { top: '12%', left: '88%', size: 14, color: '#34d399', rotate: -18 },
  { top: '22%', left: '6%', size: 12, color: '#60a5fa', rotate: 32 },
  { top: '18%', left: '92%', size: 16, color: '#f472b6', rotate: -8 },
  { top: '78%', left: '8%', size: 15, color: '#a78bfa', rotate: 22 },
  { top: '82%', left: '90%', size: 13, color: '#fbbf24', rotate: -28 },
  { top: '88%', left: '18%', size: 11, color: '#34d399', rotate: 14 },
  { top: '86%', left: '78%', size: 17, color: '#60a5fa', rotate: -12 },
  { top: '68%', left: '4%', size: 10, color: '#f472b6', rotate: 40 },
  { top: '70%', left: '94%', size: 12, color: '#a78bfa', rotate: -36 },
] as const

export function ShareCardDecorations() {
  return (
    <div aria-hidden>
      {CONFETTI_DOTS.map((dot, index) => (
        <span
          key={index}
          style={{
            position: 'absolute',
            top: dot.top,
            left: dot.left,
            width: dot.size,
            height: dot.size,
            borderRadius: '50%',
            background: dot.color,
            opacity: 0.55,
            transform: `rotate(${dot.rotate}deg)`,
            boxShadow: '0 2px 8px rgba(15, 23, 42, 0.12)',
          }}
        />
      ))}
    </div>
  )
}
